import React from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';

import { version } from '../../../../saaf.version.json';

import { Form } from 'common/components';

import Validated from 'components/util/Validated';
import AuthSchemas from 'schemas/auth_schemas';

const LoginForm = ({
  values = { email: '', password: '' },
  handleValueChange,
  handleSubmit,
  errors = {},
  isSubmitted = false,
  isLoading = false,
  t = (arg) => arg,
}) => {
  return (
    <form onSubmit={handleSubmit} noValidate autoComplete="false">
      <div className="row">
        <div className="col-lg-6">
          <Form.FieldInput
            value={values.email}
            name="email"
            placeholder={t('login.fields.email')}
            error={(isSubmitted && errors.email) || {}}
            errorPrefix={'login.email'}
            handleChange={handleValueChange}
            inputSize={'lg'}
            iconLeft={'envelope'}
            iconRightSize={'lg'}
            autoFocus={true}
          />
        </div>
        <div className="col-lg-6">
          <Form.FieldInput
            value={values.password}
            name="password"
            type={'password'}
            placeholder={t('login.fields.password')}
            error={(isSubmitted && errors.password) || {}}
            errorPrefix={'login.password'}
            handleChange={handleValueChange}
            inputSize={'lg'}
            iconLeft={'lock'}
            iconRightSize={'lg'}
          />
        </div>
        <div className="col-md-12">
          <Form.Button
            text={t('login.fields.submit')}
            isLoading={isLoading}
            extraClassName={'btn-lg pull-right btn-md-block'}
          />
          <Form.Link
            to={'/auth/recover_password'}
            className="btn btn-lg btn-link pull-right btn-md-block"
          >
            {t('login.fields.recovery')}
          </Form.Link>
          Version {version}
        </div>
      </div>
    </form>
  );
};

LoginForm.propTypes = {
  errors: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  handleValueChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isSubmitted: PropTypes.bool,
  t: PropTypes.func,
  values: PropTypes.shape({
    email: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
  }).isRequired,
};

export default Validated(AuthSchemas.login)(translate()(LoginForm));



// WEBPACK FOOTER //
// src/modules/auth/components/form/LoginForm.js